import { Address } from '@dsivd/prestations-ng';

import { CadorReference } from './cador-reference';

export class LegalRepresentative {

    isLegalRepresentativeRequestInitiator: boolean;

    relation: CadorReference;

    lastName: string;

    firstName: string;

    address: Address;

    additionalAddress: string;

    phone: string;

    email: string;

}
